export const PRIORITY_LOW = 'Low';
export const PRIORITY_MEDIUM = 'Medium';
export const PRIORITY_HIGH = 'High';

export const PRIORITY_OPTIONS = [
  { label: 'Low', value: PRIORITY_LOW },
  { label: 'Medium', value: PRIORITY_MEDIUM },
  { label: 'High', value: PRIORITY_HIGH },
];
